'use strict';

var import2bCtrl = ['$state', '$scope', 'Department', 'dialog', '$translate', function ($state, $scope, Department, dialog, $translate) {
    var _this = this;
    this.selectedTemplate = "";
    this.selectedForm = null;
    this.listfields = [];
    this.task = null;
    this.actual = true;

    this.datePopup = false;
    this.endDatePopup = false;
    this.dateOptions = {
        minDate: new Date(),
        showWeeks: false
    };

    this.endDateOptions = {
        minDate: new Date(),
        showWeeks: false
    };

    this.updateEndDates = function () {
        _this.endDateOptions.minDate = _this.task.date;
    };

    this.updateEndDate = function () {
        var hours = _this.task.endDate.getHours();
        var minutes = _this.task.endDate.getMinutes();
        var endDate = new Date(_this.task.startDate);
        endDate.setHours(hours);
        endDate.setMinutes(minutes);
        _this.task.endDate = endDate;
    };

    this.useTemplate = function (value1, value2, value3) {
        // console.log('value1 template', value1);
        if (typeof value1 === 'string') {
            this.task = {}
            this.payloadCols = {}
            this.payloadHidden = {}
            this.selectedTemplate = "";
        } else {
            this.selectedTemplate = value1;

            this.selectedForm = value1.form;
            this.listfields = this.selectedForm.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));
    
            // Set in localStorage the selected template 
            localStorage.setItem("advancedTemplateID", JSON.stringify(this.selectedTemplate.id));
   
            this.task = {}
            this.task = JSON.parse(JSON.stringify(value1));
            this.payloadCols = {}
            this.payloadHidden = {}
            this.colnumber = $state.importTasks.colnumber;
            // console.log('this.colnumber', this.colnumber);
            this.task.manualDate = false;
            this.task.users = '';

            this.task.calendarSelection = 'dynamic'; // Default value: dynamic, else manual.
            // Manual Calendar
            this.task.startDate = new Date();
            this.task.endDate = new Date();
            this.task.endDate = new Date(this.task.endDate.setHours(_this.task.startDate.getHours() + 1));
            // Dynamic Calendar
            this.task.dateCol = '';
            this.task.startDateCol = '';
            this.task.endDateCol = '';

            this.payloadData = $state.importTasks.data
            if (_this.task.payloadCols == undefined) {
                _this.task.payloadCols = {}
            }
            if (_this.task.payloadHidden == undefined) {
                _this.task.payloadHidden = {}
            }
       
            this.task.payload = this.task.payload.map((item) => {
                console.log('payload item')
                if (typeof item === 'string') {
                    let newItem = {
                        key: item,
                        value: null,
                        fieldId: null,
                        id: Math.random().toString(36).substr(2, 9)
                    }
                    return newItem;
                } else {
                    return {
                        key: item.key ? item.key : null,
                        value: item.value ? item.value : null,
                        fieldId: item.fieldId || null,
                        id: item.id ? item.id : Math.random().toString(36).substr(2, 9),
                    }
                }
            });
            // console.log('this.task.payload', this.task.payload)

            this.task.payload.forEach((field, idx) => {
                if (idx < $state.importTasks.colnumber) {
                    _this.payloadCols[field.key] = _this.task.payloadCols[field.key] || "col" + (idx + 1);
                    _this.payloadHidden[field.key] = _this.task.payloadHidden[field.key] || false;
                }
            });

            // Get Users Col number from localStorage
            var usersColLocalStorage = localStorage.getItem('advancedUsersCol');
            if (usersColLocalStorage !== "undefined" && usersColLocalStorage !== null) {
                var advancedUsersCol = JSON.parse(usersColLocalStorage);
                if (advancedUsersCol !== null && advancedUsersCol !== undefined) {
                    var userColNumber = advancedUsersCol.replace('col', '');
                    if (userColNumber < (this.colnumber + 1)) {
                        this.task.users = advancedUsersCol;
                    }
                }
            }

            // Get Date Col number from localStorage
            var dateColLocalStorage = localStorage.getItem('advancedDateCol');
            if (dateColLocalStorage !== "undefined" && dateColLocalStorage !== null) {
                var advancedDateCol = JSON.parse(dateColLocalStorage);
                if (advancedDateCol !== null && advancedDateCol !== undefined) {
                    var dateColNumber = advancedDateCol.replace('col', '');
                    if (dateColNumber < (this.colnumber + 1)) {
                        this.task.dateCol = advancedDateCol;
                    }
                }
            }

            // Get Start Date Col number from localStorage
            var startDateColLocalStorage = localStorage.getItem('advancedStartDateCol');
            // console.log('startDateColLocalStorage', startDateColLocalStorage);
            if (startDateColLocalStorage !== "undefined" && startDateColLocalStorage !== null) {
                var advancedStartDateCol = JSON.parse(startDateColLocalStorage);
                // console.log('advancedStartDateCol', advancedStartDateCol);
                if (advancedStartDateCol !== null && advancedStartDateCol !== undefined) {
                    var startDateColNumber = advancedStartDateCol.replace('col', '');
                    // console.log('startDateColNumber', startDateColNumber);
                    if (startDateColNumber < (this.colnumber + 1)) {
                        this.task.startDateCol = advancedStartDateCol;
                        // console.log('this.task.startDateCol', this.task.startDateCol);
                    }
                }
            }

            // Get End Date Col number from localStorage
            var endDateColLocalStorage = localStorage.getItem('advancedEndDateCol');
            if (endDateColLocalStorage !== "undefined" && endDateColLocalStorage !== null) {
                var advancedEndDateCol = JSON.parse(endDateColLocalStorage);
                if (advancedEndDateCol !== null && advancedEndDateCol !== undefined) {
                    var endDateColNumber = advancedEndDateCol.replace('col', '');
                    if (endDateColNumber < (this.colnumber + 1)) {
                        this.task.endDateCol = advancedEndDateCol;
                    }
                }
            }

            // console.log('usersColLocalStorage', usersColLocalStorage);
            // console.log('advancedUsersCol', advancedUsersCol);
            // console.log('userColNumber', userColNumber);
            // console.log('this.colnumber', this.colnumber);
            // console.log('userColNumber < this.colnumber', userColNumber < this.colnumber);
        }
    }

    this.getValue = function (value, row = 0, isCoord = false) {
        if (value == undefined) {
            value = "";
        }
        for (var i = 1; i <= $state.importTasks.colnumber; i++) {
            var re = new RegExp("{col".concat(i, "}"), "g");
            value = value.replace(re, $state.importTasks.data[row]["col".concat(i)])
        }
        if (isCoord && !isNaN(parseFloat(value)) && parseFloat(value) == parseInt(value)) {
            let ret = parseFloat(value);
            value = ret * 10 ** -(Math.abs(ret).toString().length - 2);
        }
        return value;
    }

    this.getTemplates = function (value, initial) {
        _this.useTemplate('', '', '');

        var query = {
            id: $state.params.departmentId,
            filter: { include: 'form' }
        };

        if (value) {
            query.filter.where = {
                name: {
                    regexp: '/^' + value + '/i'
                }
            };
        }

        return Department.tasktemplate(query)
            .$promise
            .then(function (forms) {
				
				// Select initial value
                if (initial === 'init') {
                    var templateLocalStorage = localStorage.getItem('advancedTemplateID');
                    if (templateLocalStorage !== "undefined" && templateLocalStorage !== null) {
						var advancedTemplateID = JSON.parse(templateLocalStorage);
						if (advancedTemplateID !== null && advancedTemplateID !== undefined) {
							forms.forEach((form) => {
								if (advancedTemplateID === form.id) {
									_this.useTemplate(form, '', '');
								}
							})
						}
                    }
                }

                return forms;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.nextStep = function () {
        // console.log('this.selectedTemplate', this.selectedTemplate);
        // console.log('this.task', this.task)
        // console.log('_this.task', _this.task)
        // console.log("(this.task.dateCol === '' || this.task.startDateCol === '' || this.task.endDateCol === '')", (this.task.dateCol === '' || this.task.startDateCol === '' || this.task.endDateCol === ''));
        // console.log('this.task.dateCol', this.task.dateCol)
        // console.log('this.task.startDateCol', this.task.startDateCol)
        // console.log('this.task.endDateCol', this.task.endDateCol)

        // console.log("this.task.calendarSelection === 'dynamic'", this.task.calendarSelection === 'dynamic');
        
        if (
            this.selectedTemplate === undefined || this.selectedTemplate === '' ||
            this.task.name === undefined || this.task.name === '' || 
            this.task.description === undefined || this.task.description === '' || 
            this.task.calendarSelection === 'dynamic' && (this.task.dateCol === '' || this.task.startDateCol === '' || this.task.endDateCol === '')) 
        {
            let error = '';
            if (this.selectedTemplate === undefined || this.selectedTemplate === '') {
                error = $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_FORM_TEMPLATE")
            } else if (this.task.name === undefined || this.task.name === '') {
                error = $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_FORM_TASK_NAME")
            } else if (this.task.description === undefined || this.task.description === '') {
                error = $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_FORM_TASK_DESC")
            } else if (this.task.calendarSelection === 'dynamic') {
                if (this.task.dateCol === ''){
                    error = $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_FORM_CALENDAR_DATE")
                } else if (this.task.startDateCol === '') {
                    error = $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_FORM_CALENDAR_START")
                } else if (this.task.endDateCol === '') {
                    error = $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_FORM_CALENDAR_END")
                }
            }
            this.formError(error);
        } else {
            // Set users col number
            localStorage.setItem("advancedUsersCol", JSON.stringify(this.task.users));

            if (this.task.calendarSelection === 'dynamic') {
                localStorage.setItem("advancedDateCol", JSON.stringify(this.task.dateCol));
                localStorage.setItem("advancedStartDateCol", JSON.stringify(this.task.startDateCol));
                localStorage.setItem("advancedEndDateCol", JSON.stringify(this.task.endDateCol));
            }
    
            $state.importTasks.payloadCols = _this.payloadCols;
            _this.selectedTemplate.payloadCols = _this.payloadCols;
            _this.selectedTemplate.payloadHidden = _this.payloadHidden;
            $state.importTasks.payloadHidden = _this.payloadHidden
            $state.importTasks.template = _this.task;
            Department.tasktemplate.updateById({
                id: $state.params.departmentId,
                fk: _this.selectedTemplate.id
            }, _this.selectedTemplate)
                .$promise
                .then(function (template) {
                  _this.openpage3();
                  _this.actual = false;
                })
                .catch(function (error) {
                    console.log(error);
                });

        }
    }

    this.formError = function(error) {
        dialog.alert({
            title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_FORM"),
            body: error,
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: 'md'
        });
    }

    _this.getTemplates('', 'init');
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            openpage3: '=',
            close: '=',
        },
        controller: import2bCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-tasks-advanced/imports/2b.html',
    };
};
